import React, { useState } from 'react';
import { Form, Button, InputGroup, Image } from 'react-bootstrap';
import axios from '../axiosConfig';
import { useLanguage } from "../LanguageContext";
import register from '../assets/images/register.png';
import { toast } from 'react-hot-toast';

/* Registration form used in the Register page from My Account*/

const RegisterForm = () => {
  const { language, translations } = useLanguage();
  const text = translations[language].register;

  const [first_name, setFirstName] = useState('');
  const [last_name, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [address, setAddress] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if all passwords match
    if (password !== confirmPassword) {
      alert('The passwords do not match.');
      return;
    }

    try {
      const response = await axios.get('/sanctum/csrf-cookie');

    } catch (error) {
      console.error('Query error:', error);
    }

    toast.promise(
      axios.post('/api/register', {
        first_name,
        last_name,
        email,
        phone,
        address,
        password,
        password_confirmation: confirmPassword
      }),
      {
        loading: 'Inscription en cours...',
        success: 'Inscription réussie, vous êtes connecté.',
        error: 'Erreur lors de l’inscription.',
      }
    ).then(() => {
      console.log('You are connected, you will be redirected!');
      //window.location.href = '/dashboard'; 
    }).catch((error) => {
      console.error('Erreur lors de l’inscription:', error);
    });
  };

  const inputlist = [
    { controlId : "formFirstName", label: text.firstName, type :"text", placeholder: text.enterFirstName, value: first_name, onChange: setFirstName },
    { controlId : "formLastName", label: text.lastName, type :"text", placeholder: text.enterLastName, value: last_name, onChange: setLastName },
    { controlId : "formEmail", label: "Email", type :"email", placeholder: text.enterEmail, value: email, onChange: setEmail },
    { controlId : "formPhone", label: text.phone, type :"tel", placeholder: text.enterPhone, value: phone, onChange: setPhone },
    { controlId : "formAddress", label: text.address, type :"text", placeholder: text.enterAddress, value: address, onChange: setAddress },
    { controlId : "formPassword", label: text.password, type :"password", placeholder: text.password, value: password, onChange: setPassword },
    { controlId : "formConfirmPassword", label: text.confirmPassword, type :"password", placeholder: text.confirmPassword, value: confirmPassword, onChange: setConfirmPassword }
  ];

  return (
    <>
      <h6 className='top_sentence' style={{paddingLeft:"5px"}}>Enter your ID</h6>
      <Form className="p-0 m-0" onSubmit={handleSubmit}>
        {inputlist.map((input, index) => (
          <Form.Group controlId={input.controlId} style={{ marginBottom: "3px"}} key={index}>
            <InputGroup>
              <InputGroup.Text className='input-label'style={{minWidth: "225px"}}>
                {input.label}
              </InputGroup.Text>
              <Form.Control
                type={input.type}
                placeholder={input.placeholder}
                value={input.value}
                onChange={(e) => input.onChange(e.target.value)}
              />
            </InputGroup>
          </Form.Group>
        ))}

        <Button variant="light" 
          type = "submit"
          className="btn-sm text-start align-self-start border-0 p-0 pt-1"  
          style={{ 
            backgroundColor: "white", 
            boxShadow: "none",
          }}
        >
          <div className="d-flex align-items-center">
            <Image src={register} width={30} height={30} alt="Register Icon" />
            <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>{text.submit}</span>
          </div>
        </Button>
      </Form>
    </>
  );
};

export default RegisterForm;